import { InputAdornment, TextField, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import SearchIcon from "@mui/icons-material/Search";
import React from "react";

export interface TableSearchProps {
  searchTerm: string;
  captionText: string;
  onChange: (searchTerm: string) => void;
  storageKey?: string;
}

const useStyles = makeStyles((theme) => ({
  searchContainer: {
    display: "flex",
    justifyContent: "flex-start",
    marginTop: "5px",
    marginBottom: theme.spacing(2),
    width: theme.spacing(30),
    flexDirection: "column",
  },
}));

function TableSearch({
  searchTerm,
  captionText,
  onChange,
  storageKey,
}: Readonly<TableSearchProps>) {
  const classes = useStyles();

  React.useEffect(() => {
    if (storageKey) {
      const storedSearchTerm = sessionStorage.getItem(storageKey);
      if (storedSearchTerm) {
        onChange(storedSearchTerm);
      }
    }
  }, []);

  const handleSearchChange = (searchValue: string) => {
    searchValue = searchValue.toLowerCase();

    if (storageKey) {
      sessionStorage.setItem(storageKey, searchValue);
    }

    onChange(searchValue);
  }

  return (
    <div className={classes.searchContainer}>
      <TextField
        value={searchTerm}
        onChange={(ev) => handleSearchChange(ev.target.value)}
        variant="outlined"
        placeholder="Search"
        InputProps={{
          endAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
      <Typography variant="caption">{captionText}</Typography>
    </div>
  );
}

export default TableSearch;
